<template>
  <div>
    <van-nav-bar title="外出办事审批" left-text="返回" right-text="" @click-left="onClickLeft"/>
    <van-collapse v-model="activeNames">
      <van-collapse-item title="公出规则说明" name="1" icon="calendar-o">{{ this.tips }}</van-collapse-item>
    </van-collapse>
    <van-cell title="申请人">
      <template slot="default">
        <span>{{ this.form.createUserName }}</span>
      </template>
    </van-cell>
    <van-cell title="申请时间">
      <template slot="default">
        <span>{{ this.form.createTime }}</span>
      </template>
    </van-cell>
    <van-cell title="开始时间">
      <template slot="default">
        <span>{{ this.form.beginTime }}</span>
      </template>
    </van-cell>
    <van-cell title="结束时间">
      <template slot="default">
        <span>{{ this.form.endTime }}</span>
      </template>
    </van-cell>
    <van-cell title="外出天数">
      <template slot="default">
        <span>{{ this.form.day }}</span>
      </template>
    </van-cell>
    <van-cell title="外出地点">
      <template slot="default">
        <span>{{ this.form.place }}</span>
      </template>
    </van-cell>
    <van-cell title="外出原因">
      <template slot="default">
        <span>{{ this.form.reason }}</span>
      </template>
    </van-cell>
    <van-field name="applyFile" label="申请附件" v-if="form.allFiles.applyFiles.length > 0">
      <template slot="input">
        <van-uploader v-model="form.allFiles.applyFiles" :deletable="false" :show-upload="false"></van-uploader>
      </template>
    </van-field>
    <van-collapse v-model="auditActive">
      <van-collapse-item title="审批过程" name="1" icon="browsing-history-o">
        <van-steps direction="vertical" :active="flowList.length -1">
          <van-step v-for="(item, index) in flowList" v-if="index > 0">
            <h3>【{{ item.historyActivityName }}】{{ item.assigneeName }}</h3>
            <h3 v-if="!item.historyActivityName.includes('申请')">
              【审批意见】{{ auditStatusToString(item.variables.auditStatus) }}</h3>
            <h3 v-if="!item.historyActivityName.includes('申请')">【备注】{{ item.comment }}</h3>
            <p>{{ item.createTime }}</p>
          </van-step>
        </van-steps>
      </van-collapse-item>
    </van-collapse>
    <van-field name="auditRadio" label="审批意见">
      <template slot="input">
        <van-radio-group v-model="auditStatus" direction="horizontal">
          <van-radio v-for="audit in auditStatusList" :name="audit.dictKey">{{ audit.dictValue }}</van-radio>
        </van-radio-group>
      </template>
    </van-field>
    <van-field
      v-model="form.comment"
      rows="3"
      autosize
      label="备注"
      type="textarea"
      maxlength="50"
      placeholder="请填写备注"
      show-word-limit/>
    <van-field name="auditFile" label="上传附件">
      <template slot="input">
        <van-uploader :before-read="beforeAuditFileRead" :after-read="afterAuditFileRead"
                      :max-size="5000 * 1024" max-count="6" v-model="showFiles" multiple
                      :before-delete="beforeAuditFileDelete"
                      accept="image/*,.pdf,.doc,.docx,.xml,.dwg,.ppt,.pptx,.txt,.xls,.xlsx,.zip,.rar">
        </van-uploader>
      </template>
    </van-field>

    <div style="margin: 16px;">
      <van-button round block type="info" native-type="submit" @click="showProcessInfo">提交</van-button>
    </div>

    <ProcessDialog ref="showProcessDialog" :submitFlowMethod="submitFlowMethod"
                   :getFlowParamsMethod="getFlowParamsMethod"/>
  </div>
</template>

<script>
import {Dialog, Toast} from "vant";
import {isLogin, isWechat, replaceUrl} from "../../../utils/util";

export default {
  name: "awayAudit",
  data() {
    return {
      activeNames: ['1'],
      auditActive: ['0'],
      tips: '',
      taskId: '',
      leaveTaskId: '',
      processInstanceId: '',
      processDefinitionId: '',
      appNo: '',
      processShow: false,
      form: {
        flow: {
          assigneeName: '',
        },
        allFiles: {
          applyFiles: [],
          auditFiles: [],
          removedFiles: [],
        },
        comment: '',
        activeName: '',
      },
      auditStatus: '1',
      auditStatusList: [],
      showFiles: [],
      auditFileIds: [],
      outLine: '',
      flowList: [],
      workOvertimeStatusList: [],
      workOvertimeTypeList: [],
      modelKey: "away",
    }
  },
  mounted() {
    if(!isLogin()){
      this.$router.push({
        path: "/attenceflow/Error",
        query: {
        }
      });
    }
    this.appNo = this.$route.query.appNo;
    this.processInstanceId = this.$route.query.processInstanceId;
    this.taskId = this.$route.query.taskId;
    this.processDefinitionId = this.$route.query.processDefinitionId;
    this.init();
  },
  methods: {
    onClickLeft: function () {
      let path = '/attenceflow/FlowList';
      this.$router.push({
        path: path,
        query: {}
      });
    },
    dictionaryInit() {
      this.$fetch("/attence-api/blade-system/param/getSystemParam", {
        key: 'AWAY_PROMPT'
      }).then(res => {
        const data = res.data;
        if (data != null) {
          this.tips = data;
        }
      });
    },
    init() {
      this.dictionaryInit();
      this.$fetch("/attence-api/blade-away/away/flowDetailByFlowAppNo", {
        flowAppNo: this.appNo
      }).then(res => {
        const data = res.data;
        this.form = data;
        this.form.allFiles.applyFiles.forEach(v => {
          v.url = replaceUrl(v.viewUrl);
        });
        this.$fetch("/attence-api/blade-system/dict-biz/dictionary-tree", {
          code: 'audit_status'
        }).then(res => {
          const data = res.data;
          this.auditStatusList = data;
          this.$fetch("/attence-api/blade-flow/process/history-flow-list", {
            processInstanceId: this.processInstanceId
          }).then(res => {
            const data = res.data;
            this.flowList = data;
            //this.activeName = this.flowList[1].historyActivityName;
            this.outLine = this.flowList[1].variables.outLine;
          });
        });

      });
    },
    // 返回布尔值
    beforeAuditFileRead(file) {
      return true;
    },
    afterAuditFileRead(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      // 此时可以自行将文件上传至服务器
      console.log(file);
      let formData = new FormData();
      formData.append('file', file.file);
      formData.append('bizColumn', 'auditFiles');
      this.$filePost("/attence-api/blade-manager/bizAttach/upload", formData).then(
        res => {
          const data = res.data;
          file.status = 'done';
          file.message = '上传成功';
          this.auditFileIds.push(data.id);
          this.form.allFiles.auditFiles.push(data);
          console.log("IDS：" + JSON.stringify(data));
        },
        error => {
          file.status = 'failed';
          file.message = '上传失败';
        }
      );
    },
    beforeAuditFileDelete(file, detail) {
      let index = JSON.stringify(detail.index);
      let delId = this.auditFileIds[index];
      let url = "/attence-api/blade-manager/bizAttach/remove";
      this.$post(url, {
        ids: delId,
      }).then(
        res => {
          const data = res.data;
          this.auditFileIds.splice(index, 1);
          Toast('刪除成功');
          console.log("IDS：" + this.auditFileIds);
        },
        error => {
        }
      );
      return true;
    },
    jumpPage() {
      let path = '/attenceflow/FlowList';
      this.$router.push({
        path: path,
        query: {}
      });
    },
    handleAudit() {
      const params = {
        taskId: this.taskId,
        processInstanceId: this.processInstanceId,
        flag: 'ok',
        comment: this.form.comment,
        variables: {
          step: "audit",
          auditStatus: this.auditStatus
        },
      };

      this.form.flow = params;
      //this.form.allFiles = this.allFiles;
      this.$bodyPost("/attence-api/blade-away/away/complete-task", this.form).then(res => {
        const data = res.data;
        if (data == 0) {
          Toast("审批成功，流程结束！");
        } else {
          Toast(res.msg);
        }
        this.processShow = true;
      });
    },
    showProcessInfo() {
      if (this.auditStatus != '1') {
        if (!this.form.comment) {
          Toast('请先填写备注');
          return;
        }
      }
      //展示对话框
      this.$refs.showProcessDialog.showProcessInfo();
    },
    submitFlowMethod() {
      this.handleAudit();
    },
    getFlowParamsMethod() {
      //用于对话框展示请求接口参数
      const params = {
        businessId: this.form.id,
        taskId: this.taskId,
        processInstanceId: this.processInstanceId,
        flag: 'ok',
        processDefinitionKey: this.modelKey,
        variables: {
          auditStatus: this.auditStatus,
        },
      };

      return params;
    },
  }
}
</script>

<style scoped>
.van-nav-bar {
  background-color: #2196f3;
}

/deep/ .van-nav-bar__title {
  color: #fff;
}

/deep/ .van-nav-bar__text {
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/pages/attenceflow/away/audit.vue